<script setup></script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 19.658 36.704"
        fill="currentColor"
        aria-hidden="true"
    >
        <path
            d="M41.26,20.646,42.279,14H35.906V9.693c0-1.817.89-3.589,3.745-3.589h2.9V.449A35.336,35.336,0,0,0,37.4,0c-5.249,0-8.68,3.182-8.68,8.941V14H22.89v6.643h5.835V36.7h7.181V20.646Z"
            transform="translate(-22.89)"
        />
    </svg>
</template>
